import React, { useState } from "react";
import RouteAllowed from "../../../helper/isRouteAllowed";
import { SearchTagRefresh } from "../../../core";
import VisibleColumnToggler from "../../../helper/visibleColumnToggler";
import DesktopBreakpoint from "../../../context/desktop_breakpoint";
import PhoneBreakpoint from "../../../context/phone_breakpoint";

const UserHeader = props => {
  const [showSearchBoxForMobile, setShowSearchBoxForMobile] = useState(false);
  return (
    <div className="d-flex contentHeader">
      <div className="mr-auto">
        <RouteAllowed roles={props.rolesUH} permission={props.permissionUH}>
          {/* <Link to="/dashboard/addUser" className="mr-auto"> */}
          <button
            className="mr-auto primaryButton primaryButton--contentHeader"
            onClick={() => props.handleUserCreate(true, "create")}
            // onClick={handleSubmit(values => this.handleLogin(values))}
            type="submit"
          >
            <i className="fa fa-plus mr-2" />
            <DesktopBreakpoint>Add User</DesktopBreakpoint>
            <PhoneBreakpoint>Add</PhoneBreakpoint>
          </button>
          {/* </Link> */}
        </RouteAllowed>{" "}
      </div>
      <div className="d-flex flex-row-reverse">
        <PhoneBreakpoint>
          <div
            role="presentation"
            className="ml-2 contentHeader__searchContainer"
            onClick={() => {
              setShowSearchBoxForMobile(!showSearchBoxForMobile);
            }}
          >
            <i className=" bx bx-search bx-sm " />
          </div>
        </PhoneBreakpoint>
        <div
          className={`searchContaainerForMobile ${showSearchBoxForMobile &&
            "expandedSearch"}`}
        >
          <SearchTagRefresh handleSearch={props.handleSearchValue} {...props} />

          {/* will render on mobile phone; extra component for the phone view */}

          <PhoneBreakpoint>
            <div
              className="closeSearchContainer"
              onClick={() => {
                setShowSearchBoxForMobile(!showSearchBoxForMobile);
              }}
            >
              <i className="mr-0 fa fa-times " />
            </div>
          </PhoneBreakpoint>
        </div>
      </div>
      <VisibleColumnToggler
        hiddenColumns={props.hiddenColumns}
        toggleHiddenColumns={props.toggleHiddenColumns}
        columnToggleProps={props.columnToggleProps}
      />
    </div>
  );
};

export default UserHeader;
